// src/services/api/baseService.js
import easyCheckApi, { easyCheckRequest } from './config';

export const createCrudService = (resource) => ({
  getAll: (params = {}) => easyCheckRequest(() => easyCheckApi.get(`/${resource}`, { params })),
  getById: (id) => easyCheckRequest(() => easyCheckApi.get(`/${resource}/${id}`)),
  create: (data) => easyCheckRequest(() => easyCheckApi.post(`/${resource}`, data)),
  update: (id, data) => easyCheckRequest(() => easyCheckApi.put(`/${resource}/${id}`, data)),
  delete: (id) => easyCheckRequest(() => easyCheckApi.delete(`/${resource}/${id}`)),
}); 